import {Code} from "@/v2/i18n/modules/zhTW/status/code";

export const Status = {

    code: Code

}